import { render, staticRenderFns } from "./workFlowHistory.vue?vue&type=template&id=9965db9c&scoped=true&"
import script from "./workFlowHistory.vue?vue&type=script&lang=js&"
export * from "./workFlowHistory.vue?vue&type=script&lang=js&"
import style0 from "./workFlowHistory.vue?vue&type=style&index=0&id=9965db9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965db9c",
  null
  
)

export default component.exports